import * as yup from "yup";

export const dadosEmitirNotaSchema = yup.object().shape({
    nomePessoa: yup.string().max(50, "O nome não pode ter mais que 50 caracteres"),
    numeroPessoa: yup.string(),
    tipoPessoa: yup.string().default("CPF")
})